import React from "react";

import { Badge, Avatar, makeStyles, withStyles } from "@material-ui/core";

// Styled Badge
const StyledBadge = withStyles((theme) => ({
  badge: {
    top: 0,
    right: 0,
    backgroundColor: "#44b700",
    color: "#44b700",
    boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
    "&::after": {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      borderRadius: "50%",
      animation: "$ripple 1.2s infinite ease-in-out",
      border: "1px solid currentColor",
      content: '""',
    },
  },
  "@keyframes ripple": {
    "0%": {
      transform: "scale(.8)",
      opacity: 1,
    },
    "100%": {
      transform: "scale(2.4)",
      opacity: 0,
    },
  },
}))(Badge);

// Styles
const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    "& > *": {
      margin: theme.spacing(1),
    },
  },
}));

// Interfaces
interface IProfileAvatar {
  src: string;
}

// Render
const ProfileAvatar = ({ src }: IProfileAvatar) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <StyledBadge
        overlap="circle"
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        variant="dot"
      >
        <Avatar
          alt="Profile Avatar"
          src={src}
          style={{ height: 100, width: 100 }}
        />
      </StyledBadge>
    </div>
  );
};

export default ProfileAvatar;
